import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  AppendOrCreateContactApplicationErrors,
  AppendOrCreateContactOptions,
  SubmitContactResponse,
  appendOrCreateContact as universalAppendOrCreateContact,
} from './contacts-v4-submit-contact-submitted-contact.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/crm' };

export function appendOrCreateContact(
  httpClient: HttpClient
): AppendOrCreateContactSignature {
  return (options?: AppendOrCreateContactOptions) =>
    universalAppendOrCreateContact(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface AppendOrCreateContactSignature {
  /**
   * Appends an existing contact or creates a contact if it doesn't exist.
   *
   * For internal docs, see
   * [Submit Contacts](crm.contact-submit-service.introduction).
   */
  (options?: AppendOrCreateContactOptions): Promise<
    NonNullablePaths<
      SubmitContactResponse,
      `contactId` | `identityType` | `newContact`,
      2
    > & {
      __applicationErrorsType?: AppendOrCreateContactApplicationErrors;
    }
  >;
}

export {
  AccountInfo,
  ActivityIcon,
  Address,
  AddressLocation,
  AddressStreetOneOf,
  AddressTag,
  AppendOrCreateContactOptions,
  AssigneesWrapper,
  ContactActivity,
  ContactActivityType,
  ContactAddress,
  ContactAddressesWrapper,
  ContactEmail,
  ContactEmailsWrapper,
  ContactInfo,
  ContactName,
  ContactPhone,
  ContactPhonesWrapper,
  ContactPicture,
  ContactSourceType,
  ContactToSubmit,
  EmailTag,
  ExtendedFieldsWrapper,
  IdentificationData,
  IdentificationDataIdOneOf,
  IdentityType,
  ImageProvider,
  LabelsWrapper,
  LocationsWrapper,
  MessageEnvelope,
  PhoneTag,
  StreetAddress,
  Subdivision,
  SubdivisionType,
  SubmitContact,
  SubmitContactOptions,
  SubmitContactRequest,
  SubmitContactResponse,
  SubmitOperation,
  SubmitVisitorIdRequest,
  SubmitVisitorIdResponse,
  WebhookIdentityType,
} from './contacts-v4-submit-contact-submitted-contact.universal.js';
